// extracted by mini-css-extract-plugin
export default {"app_header":"g-fhylOesY22Ax34PWihDw=="};